<template>
  <div>
    <!-- 首页强制弹窗 -->
    <Modal v-model="visible" width="800px" :footer-hide="true" :mask-closable="false" class="my-modal force-modal" :before-close="handleCancel">
      <div class="modal-title">{{ formData.title }}</div>
      <div class="modal-body" ref="content">
        <div class="modal-time">发布时间：{{ formData.createTime | filterTime('YYYY-MM-DD') }}</div>
        <div class="modal-content w-e-text" v-html="formData.content"></div>
      </div>
      <!-- 强制弹窗 -->
      <div class="ivu-modal-footer" v-if="formData.isForce == 1">
        <Button type="primary" @click="readAndClose" class="submit-btn" :disabled="!isLook">确认收到并已知悉相关信息</Button>
        <p class="info-text" v-if="isBigContent">重要通知，请向下滑动阅读完毕后点击上方按钮</p>
        <p class="info-text" v-else>重要通知，请阅读完毕后点击上方按钮</p>
      </div>
      <!-- 非强制弹窗 -->
      <div class="ivu-modal-footer" v-else>
        <Button type="primary" @click="readAndClose" class="submit-btn">我知道了</Button>
      </div>
    </Modal>

    <!-- 确认弹窗 -->
    <confirm-modal ref="confirmModal"></confirm-modal>
  </div>
</template>

<script>
import confirmModal from '@/components/commons/confirmModal';
export default {
  components: { confirmModal },
  props: [],
  data() {
    return {
      visible: false,
      loading: false,
      isBigContent: false, // 是否超出一屏
      isLook: false, // 是否完整查看
      formData: {}
    };
  },
  methods: {
    async open() {
      const data = await this.getDetailData();
      if (!data || !data.id) {
        return;
      }
      if (data.content) {
        data.content = data.content.replace(/<img/g, '<img preview');
      }
      this.formData = data;
      this.visible = true;
      if (data.isForce == 1) {
        // 强制弹窗
        window.setTimeout(() => {
          const a = this.$refs.content;
          // 低于一屏直接标记已查看
          if (a.scrollTop + a.clientHeight >= a.scrollHeight - 10) {
            this.isLook = true;
            return;
          }
          this.isBigContent = true;
          a.onscroll = () => {
            if (a.scrollTop + a.clientHeight >= a.scrollHeight - 10) {
              this.isLook = true;
            }
          };
        }, 1000);
      } else {
        // 非强制弹窗
        this.isLook = true;
        this.isBigContent = false;
        this.read();
      }
      window.setTimeout(() => {
        this.$previewRefresh();
      }, 500);
    },
    // 获取强制弹窗数据
    getDetailData() {
      return this.$http({
        type: 'GET',
        url: '/buz/content/popUp/getPop',
        data: {}
      }).then(res => {
        return res.data;
      });
    },
    // 关闭弹窗
    handleCancel() {
      return new Promise((resolve, reject) => {
        if (this.formData.isForce == 1) {
          // 强制弹窗,提示确认关闭
          this.$refs.confirmModal
            .open({
              title: '提示',
              width: 350,
              closable: false,
              content: '请确认是否知悉相关信息？',
              okText: '我已阅读并知悉',
              cancelText: '未读，下次再提醒我'
            })
            .then(() => {
              this.readAndClose();
              resolve();
            })
            .catch(() => {
              this.visible = false;
              reject();
            });
        } else {
          // 非强制弹窗
          resolve();
        }
      });
    },
    // 读取弹窗并关闭
    readAndClose() {
      this.read(() => {
        this.visible = false;
      });
    },
    read(callback) {
      this.$http({
        type: 'POST',
        url: '/buz/content/popUp/read',
        data: {
          popUpId: this.formData.id
        }
      }).then(e => {
        callback && callback();
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import './forceModal.scss';
</style>
